export default {
  // Endpoints
  loginEndpoint: '/v2/admin/login',
  loginGoogleEndpoint: '/v2/admin/login-google',
  registerEndpoint: '/jwt/register',
  refreshEndpoint: '/v2/admin/refresh',
  logoutEndpoint: '/v2/admin/logout',

  // This will be prefixed in authorization header with token
  // e.g. Authorization: Bearer <token>
  tokenType: 'Bearer',

  // Value of this property will be used as key to store JWT token in storage
  storageTokenKeyName: 'backofficeAccessToken',
  storageRefreshTokenKeyName: 'backofficeRefreshToken',
  storageTokenExpiryKeyName: 'backofficeAccessTokenExpiresAt',
  storageRefreshTokenExpiryKeyName: 'backofficeRefreshTokenExpiresAt',

  // Milliseconds before expiry to trigger an automatic refresh
  tokenRenewalLeeway: 5000,

  // Cookie preferences
  cookieTTL: 30,
}
